import {
  DISPLAY_TYPE,
  PERFORMANCE_MAX_TYPE
} from '../../forms/Google/CampaignForms/CampaignGoogleCreate/CampaignGoogleCreateForm/fields'

export const googleCampaignsTypeList = [
  {
    value: PERFORMANCE_MAX_TYPE,
    label: 'Performance Max'
  },
  {
    value: DISPLAY_TYPE,
    label: 'Display'
  }
]
